import { get, set } from "idb-keyval";

type FetchOptions = RequestInit & {
  body?: any;
  cacheTTL?: number; // в миллисекундах
};

interface CachedResponse {
  timestamp: number;
  data: any;
}

function generateCacheKey(url: string, options: FetchOptions = {}): string {
  const method = options.method || "GET";
  const body = options.body ? JSON.stringify(options.body) : "";
  return `${method}:${url}?body=${body}`;
}

export async function fetchWithCache(
  url: string,
  options: FetchOptions = {},
): Promise<any> {
  const cacheTTL = options.cacheTTL ?? 5 * 60 * 1000;
  const key = generateCacheKey(url, options);

  const cached = await get<CachedResponse>(key);
  const now = Date.now();

  if (cached && now - cached.timestamp < cacheTTL) {
    return cached.data;
  }

  const response = await fetch(url, {
    ...options,
    body: options?.body,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }

  const data = await response.json();

  await set(key, { timestamp: now, data });

  return data;
}
